var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-vertical',{scopedSlots:_vm._u([{key:"navbar",fn:function(ref){
var toggleVerticalMenuActive = ref.toggleVerticalMenuActive;
return [_c('navbar',{attrs:{"toggle-vertical-menu-active":toggleVerticalMenuActive}})]}}])},[_c('div',{attrs:{"slot":"breadcrumb"},slot:"breadcrumb"},[_c('breadcrumbs')],1),_c('div',{staticClass:"pb-3"},[_c('router-view',{key:_vm.$route.path})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }